export const notifyCheckOutCompleteHook = (order, _logger) => {
    var resultevent = false;
    var pixelData = {
        transaction_id: order.orderId,
        currency: 'USD',
        value: order.value,
        name: order.first_name,
        phone: order.phone,
        email: order.email,
        items: [{
                item_id: order.id,
                item_name: order.car.name,
                item_days: order.totalRentDays,
                affiliation: "Holacar rentals Store",
                index: 0,
                item_brand: order.renter,
                item_category: order.city,
                item_category2: order.car.sippCode,
                item_category3: order.car.sizeName,
                price: order.value,
                quantity: 1
            }]
    };
    if (window.gtag) {
        window.gtag("event", "purchase", pixelData);
        window.gtag('event', 'conversion', {
            'send_to': 'AW-11441363881/ecJ4CLfFxoIaEKm31c8q',
            'value': order.value,
            'currency': order.currency || 'USD',
            'transaction_id': order.orderId,
        });
        _logger.log(`CheckOut Completed Pixel _ga ${order._ga}name:${order.first_name} country:${order.country}
            transaction_id: ${order.orderId} currency: ${order.currency} value: ${order.value}
            item :${order.renter} ${order.city} ${order.car.name}]}`);
    }
    else {
        _logger.log(`no send Pixel _ga ${order._ga}name:${order.first_name} country:${order.country}
            transaction_id: ${order.orderId} currency: ${order.currency} value: ${order.value}
            item :${order.renter} ${order.city} ${order.car.name}]}`);
    }
    return resultevent;
};
